import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-view-company-organization',
  templateUrl: './view-company-organization.component.html',
  styleUrls: ['./view-company-organization.component.css']
})
export class ViewCompanyOrganizationComponent implements OnInit {
  response: any;
  dataSource: any = new MatTableDataSource([]);
  units: any = [];
  displayedColumns: string[] = ['name', 'status', 'operations'];
  filterStatus = true;
  loaderId = 'company-orgaanization-loader';
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalUnits: 0,
    totalPages: 0,
    currentRecords: 0
  };
  PAGE_LIMIT = 20;
  timeoutId: any;
  hasUnitsLoaded: boolean = false;
  searchUnit: string = '';
  company_id: '';
  activeFilter = "all";

  constructor(private _location: Location, public companyService: CompanyService, private toastr: ToastrService,
    private loader: NgxUiLoaderService, private route: ActivatedRoute) { }

  async ngOnInit() {
    if (window.location.pathname.includes('company')) {
      this.company_id = this.route.parent.snapshot.params.id;
    }
    this.loader.startLoader(this.loaderId);
    // await this.initUnits();
    if (this.units.length > 1) {
      this.updatePageCountForFirstPage();
    }
    this.loader.stopLoader(this.loaderId);
  }

  searchUnits() {
    let filteredUnits = [];
    if (this.searchUnit.trim().length > 0) {
      this.units.map(unit => {
        if (unit.name.toLowerCase().includes(this.searchUnit.toLowerCase()))
          filteredUnits.push(unit);
      }
      );
    }
    else
      filteredUnits = this.units;

    this.dataSource = filteredUnits;
  }

  updatePageCountForFirstPage() {
    if (this.pagination.currentRecords < this.pagination.totalUnits) {
      this.pagination.hasNextPage = true;
      this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.units.length;
    }
  }

  async goToPreviousPage() {
    this.loader.startLoader(this.loaderId);
    this.pagination.totalUnits = 0;
    this.pagination.currentRecords = 0;
    if (this.pagination.pageNo > 1) {
      this.pagination.pageNo = this.pagination.pageNo - 1;
      this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.units.length;
      // await this.initUnits();
    }
    if (this.pagination.pageNo === 1) {
      this.pagination.hasPrevPage = false;
    }
    this.pagination.hasNextPage = true;
    this.loader.stopLoader(this.loaderId);
  }

  async goToNextPage() {
    this.loader.startLoader(this.loaderId);
    this.pagination.totalUnits = 0;
    this.pagination.currentRecords = 0;
    this.pagination.pageNo = this.pagination.pageNo + 1;
    this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.units.length;
    if (this.pagination.currentRecords > this.pagination.totalUnits) {  //Page count should not exceed total limit
      this.pagination.currentRecords = this.pagination.currentRecords - (this.pagination.currentRecords - this.pagination.totalUnits);
    }
    // await this.initUnits();
    if (this.pagination.currentRecords === this.pagination.totalUnits) {
      this.pagination.hasNextPage = false;
    }
    this.pagination.hasPrevPage = true;
    this.loader.stopLoader(this.loaderId);
  }

  // async initUnits() {
  //   let response: any = await lastValueFrom(this.companyService.getCompanyUnitsAssociation({ _id: this.company_id, is_active: true, isShowAll: true }, { name: 1, category: 1 }));
  //   if (response.status == 200) {
  //     this.units = response.data[0].assoc_unit_ids;
  //     this.dataSource = this.units;
  //     this.pagination.totalUnits = this.units.length;
  //   }
  //   else {
  //     this.toastr.error(response.message, "ERROR");
  //   }
  // }

  async changeUnitActiveStatus(event) {
    let filteredUnits = [];
    if (event == 'all') {
      filteredUnits = this.units;
    }
    else if (event == "true") {
      await this.units.map(unit => {
        if (unit.is_active == true)
          filteredUnits.push(unit);
      });
    }
    else if (event == "false") {
      await this.units.map(unit => {
        if (unit.is_active == false)
          filteredUnits.push(unit);
      });
    }

    this.dataSource = filteredUnits;
  }

  // async updateUnitActiveStatus(element, event){
  //   let unitIndex = this.units.findIndex(unit => unit._id == element._id);
  //   let allUnits = [...this.units];
  //   let inActiveUnit: any = allUnits.splice(unitIndex, 1)[0];       // find unit whose status is changed
  //   inActiveUnit.is_active = event;
  //   allUnits.push(inActiveUnit);
  //   let response: any = await lastValueFrom(this.companyService.updateCompanyUnitsAssociation({ _id: this.company_id }, { $set: { assoc_unit_ids: allUnits } }));
  //   if (response.status == 200)
  //     this.toastr.success('Status Updated Successfully!', 'Success');
  //   else
  //     this.toastr.error(response.message, "ERROR");
  // }

  editUnit(element) {
    console.log("element: ", element)
    
  }

  goBack() {
    this._location.back();
  }
}
